import React from "react";

import styles from "./CustomDashboard.module.scss";

export const DashboardContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.dashboardContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const CardWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.cardWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
